
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/vue';
//import ExploreContainer from '@/components/ExploreContainer.vue';

export default  {
  name: 'modalPage',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage}
}
